import getFormEventData from '../../utils/getFormEventData';
import { eventHasRun } from '../../utils/eventTracker';
import getSection from '../../utils/getSection';

export const DDC_FORM_INITIATION = 'ddc.form.initiation';

function initiation(
	{
		DDC: {
			dataLayer = {},
			dataLayer: {
				page: { pageInfo: { pageName } = {} } = {},
				vehicles = []
			} = {}
		}
	},
	{ currentTarget, timeStamp }
) {
	let eventObject;
	const form = currentTarget?.closest('form');

	const formEventId =
		form?.querySelector('input[name="formEventId"]')?.value || '';
	const formEventData = getFormEventData({
		form,
		vehicles,
		dataLayer
	});
	const eventMapId = formEventId || formEventData.trackingId;

	// Currently typedSearch forms are not tracked for initiation.
	if (form?.dataset?.formTrackingType === 'typedSearch') {
		eventHasRun(eventMapId, {
			value: {
				formInitiationTime: new Date().getTime()
			}
		});
	} else if (
		// make sure this form has not initialized yet
		!eventHasRun(DDC_FORM_INITIATION, {
			timeStamp
		}) &&
		// only submit formInitiation once
		!eventHasRun(eventMapId, {
			value: {
				formInitiationTime: new Date().getTime()
			}
		})
	) {
		const activeElement = document.activeElement.getAttribute('name');
		const activeElementTag = document.activeElement.tagName.toLowerCase();
		const section = getSection(form);

		eventObject = {
			eventType: DDC_FORM_INITIATION,
			eventData: {
				element: form,
				formEventId,
				pageName,
				...formEventData
			}
		};

		if (section) {
			eventObject.eventData.trackingSection = section;
		}

		if (activeElement) {
			eventObject.eventData.activeElement = activeElement;
			eventObject.eventData.activeElementTag = activeElementTag;
		}
	}

	return eventObject;
}

export default initiation;
